import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom"
import { DailyComplaint } from "./DailyComplaint";


export const ViewVehicleScheduling = (props) => {

  const { DataObj } = props
  const {
    Countdata,
    isCountLoading,
    PlanationDetailsCountdata,
    YearValue,
    MonthValue,
    ZoneValue,
    DashSelect,
    Language,

  } = DataObj

  const { t } = useTranslation()

  const navigate = useNavigate()


  return (
    <div className="row m-1 mt-3 rounded_eic" >

      <div className="col-12 col-lg-12 col-xl-8 bg-white rounded_eic" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>
        <div className="row">

          <div className="col-12 col-md-12 pb-3 pt-2">

            <div className="p-3 mt-1 border border-danger rounded_eic" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
              <div className="row text-center">
                <div className="col-12 col-lg-6 border-end">
                  <div className="col-12 col-lg-12  ">
                    <div className="row">
                      <div className="col-12 mb-2">
                        <h6 className=" text-dark">{t('EncroachmentDashboard.TodaysScheduling')}</h6>
                      </div>
                      <div className="col-6  ">
                        <button type="button" class="btn eic_purple_bg position-relative cursor-pointer"
                          onClick={() => navigate(`/TodaySchedulingGrid?DashSelect=${DashSelect}&Flag=TodaysSchedule_First`)}
                        >
                          {t('EncroachmentDashboard.FirstShift')}
                          <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill eic_bg-badge">
                            {Countdata && Countdata.TodaysScheduling_FirstShift ? Countdata.TodaysScheduling_FirstShift.toFixed(0) : '0'}
                          </span>
                        </button>
                      </div>

                      <div className="col-6  ">
                        <button type="button" class="btn eic_purple_bg position-relative cursor-pointer"
                          onClick={() => navigate(`/TodaySchedulingGrid?DashSelect=${DashSelect}&Flag=TodaysSchedule_Second`)}
                        >
                          {t('EncroachmentDashboard.SeconsShift')}
                          <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill eic_bg-badge">
                            {Countdata && Countdata.TodaysScheduling_SecondShift ? Countdata.TodaysScheduling_SecondShift.toFixed(0) : '0'}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-lg-12  ">
                    <div className="row">
                      <div className="col-12 mb-2 pt-3 pt-lg-4">
                        <h6 className=" text-dark">{t('EncroachmentDashboard.TodaysAction')}</h6>
                      </div>
                      <div className="col-6 col-md-6 col-lg-6  ">

                        <button type="button" class="btn eic_purple_bg position-relative cursor-pointer"
                          onClick={() => navigate(`/TodaysActionGrid?DashSelect=${DashSelect}&Flag=TodaysScheduleCompl_First`)}
                        >
                          {t('EncroachmentDashboard.FirstShift')}
                          <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill eic_bg-badge">
                            {Countdata && Countdata.TodaysScheduleCompl_First ? Countdata.TodaysScheduleCompl_First.toFixed(0) : '0'}
                          </span>
                        </button>
                      </div>

                      <div className=" col-6 col-md-6 col-lg-6  ">
                        <button type="button" class="btn eic_purple_bg position-relative cursor-pointer"
                          onClick={() => navigate(`/TodaysActionGrid?DashSelect=${DashSelect}&Flag=TodaysScheduleCompl_Second`)}
                        >
                          {t('EncroachmentDashboard.SeconsShift')}
                          <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill eic_bg-badge">
                            {Countdata && Countdata.TodaysScheduleCompl_Second ? Countdata.TodaysScheduleCompl_Second.toFixed(0) : '0'}
                          </span>
                        </button>
                      </div>
                    </div>

                  </div>
                </div>

                <div className="col-12 col-lg-6 pt-3 pt-lg-0 ps-0 ps-lg-3">

                  <DailyComplaint
                    DataObj={DataObj} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-12 col-lg-12 col-xl-4 pt-3 pt-xl-0 ps-0 ps-xl-3 " >
        <div className="row ms-1 px-3 bg-white rounded_eic" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>

          <div className="col-12 col-md-12 pb-3 pb-lg-4 pt-2 ">
            <div className="p-2 pt-lg-3 pb-3 mt-2 mt-lg-3 border border-danger rounded_eic" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
              <div className="row text-center">
                <span className="text-dark Group_Attendance_heading_fontsize">{t('EncroachmentDashboard.GroupAttendance')}</span>
                <div className="col-12  border-end ">
                  <div className="row pt-3">
                
                    <div className=" col-6 col-md-6 col-lg-6 border-end ">
                      <button type="button" className="btn eic_shift_button position-relative cursor-pointer"
                        onClick={() => navigate(`/GroupAttendanceGrid?DashSelect=${DashSelect}&Flag=FirstShift`)}
                      >
                        {t('EncroachmentDashboard.FirstShift')}
                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill eic_bg-badge">
                          {Countdata && Countdata.TodaysScheduleCompl_Second ? Countdata.TodaysScheduleCompl_Second.toFixed(0) : '0'}
                        </span>
                      </button>
                    </div>

                    <div className=" col-6 col-md-6 col-lg-6 border-end ">
                      <button type="button" className="btn eic_shift_button position-relative cursor-pointer"
                        onClick={() => navigate(`/GroupAttendanceGrid?DashSelect=${DashSelect}&Flag=SecondShift`)}
                      >
                        {t('EncroachmentDashboard.SeconsShift')}
                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill eic_bg-badge">
                          {Countdata && Countdata.TodaysScheduleCompl_Second ? Countdata.TodaysScheduleCompl_Second.toFixed(0) : '0'}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-3 mt-3 mt-lg-4 border border-danger rounded_eic" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
              <div className="row text-center">
                <div className="col-12  ps-5 text-start cursor-pointer"
                  onClick={() => navigate(`/VehicleTrackingGrid?DashSelect=${DashSelect}`)}
                >
                  <h6 className=" fw-bold text-dark">{t('EncroachmentDashboard.VehicleTracking')}</h6>
                  <i className="fa-solid fa-truck text-danger cursor-pointer ps-4 pt-lg-2" style={{ fontSize: '25px' }}></i>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}